<template>


    <main class="">

        <div class="pt-5 text-bg-light">
            <div class="container narrow-container">
                <div class="text-center">
                    <!--                    <div class="badge bg-dark fs-4">
                                            Neu
                                        </div>-->
                    <h1 class="display-4">
                        Das Bonus-Programm
                        <br />
                        im DentaLink-Marktplatz
                    </h1>
                    <p class="fs-4 my-4">
                        Herzlich Willkommen zum Dentalink Bonusprogramm,<br>
                            hier finden Sie Sachprämien und zahlreiche Dienstleistungen, die Sie gemäß Ihrem Status einlösen können.
                    </p>
                    <div class="overflow-hidden" style="max-height: 22vh;">
                        <div class="container px-5">
                            <img src="/img/arrows-g17f9cec7b_1920.jpg" class="img-fluid border shadow-lg mb-4" alt="Screenshot Marktplatz" width="700" height="500" loading="lazy">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="py-5">

            <div class="container narrow-container">

                <div class="text-center">
                    <div class="display-3 text-primary">
                        <i class="bi bi-info-circle"></i>
                    </div>
                    <h2 class=" fw-light mt-4">
                        {{ __('Wie funktioniert das Bonusprogramm?') }}
                    </h2>
                    <p class="lh-lg">
                        Gemäß Ihrem Kundenstatus haben Sie Zugang zu bestimmten Prämien und Dienstleistungen. Sobald Sie einen neuen Status erreichen, werden automatisch die erweiterten Prämien und Dienstleistungen für Sie freigeschaltet. 
                    </p>
                    <hr class="my-5">
                        <div class="display-3 text-primary">
                            <i class="bi bi-graph-up-arrow"></i>
                        </div>
                        <h2 class=" fw-light mt-4">
                            {{ __('Wie komme ich zum nächsten Status-Level?') }}
                        </h2>
                        <p class="lh-lg">
                            Über Ihren Einkauf sammeln Sie automatisch Statuspunkte. Für 5 € Umsatz erhalten Sie 1 Statuspunkt. Zusätzlich haben Sie die Möglichkeit, gemeinsam mit Ihrem Partner (Dentallabor/Praxis) Punkte zu sammeln und den Umsatz zu “poolen”. Zukünftig wird es weitere Möglichkeiten geben, um Punkte zu sammeln (bspw. Teilnahme an Events und Schulungen).
                        </p>
                </div>


                <!--            <div class="text-center mt-5">
                                <a href="#!" class="btn btn-lg btn-outline-primary">
                {{ __('Haben Sie Fragen?') }}
                                </a>
                                <a href="my-points.php" class="btn btn-lg btn-outline-dark">
                {{ __('Ihr Punktekonto') }}
                                </a>
                            </div>-->

            </div>

        </section>


        <section class="py-5 bg-secondary">

            <div class="container">

                <div class="text-center text-white">
                    <h2 class="display-6 fw-light">
                        {{ __('Welche Prämien und Dienstleistungen gibt es?') }}
                    </h2>
                    <!--                <p class="my-4 lh-lg">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                    </p>-->
                </div>

                <div class="row row-cols-1 row-cols-lg-3 mt-5">
                    <div class="col">
                        <div class="card h-100 border-0">
                            <div class="card-body">
                                <h3 class="my-4 text-primary text-center">
                                    Bronze-Status
                                </h3>
                                <ol>
                                    <li>Individuelle Konditionen -> Wir bemühen uns täglich um verbesserte Konditionen bei allen gewünschten Partnern</li>
                                    <li>Freigabeprozesse für Bestellungen -> Legen Sie individuell fest, wie Bestellungen freigegeben werden</li>
                                    <li>Wareneingangsmanagement und Warenlager-Funktionen: Stellen Sie einfach und unkompliziert sicher, dass alle Waren eingehen, die auch bestellt wurden. Zudem können Sie sich direkt einen Verfalls Alarm für bestimmte Produkte einrichten </li>
                                    <li>MDR-Tool: Nutzen Sie kostenlos unser MDR-Tool für die gesetzlich vorgeschriebene Dokumentation im Rahmen der EU-MDR Richtlinie</li>
                                    <li>Kostenlose Jobbörse: Suchen Sie neue Mitarbeiter? Tragen Sie einfach per Formular Ihre Stellensuche in unsere Datenbank ein und wir sorgen durch kontinuierliche Suchmaschinenoptimierung für die direkte Ansprache von potentiellen Bewerbern</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card h-100 border-0">
                            <div class="card-body">
                                <h3 class="my-4 text-primary text-center">
                                    Silber-Status
                                </h3>
                                <ol>
                                    <li>Alle Funktionen und Dienstleistungen aus dem Bronze-Status</li>
                                    <li>Öffentliches Profil für Patientenmarketing und Mitarbeitersuche</li>
                                    <li>Optimierter Google-Maps Eintrag</li>
                                    <li>Kostenloses Fotoshooting für Ihre Praxis</li>
                                    <li>Eintragen von Stellengesuchen bei Jobbörsen (bspw. Stepstone, Indeed, Xing etc.)</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card h-100 border-0">
                            <div class="card-body">
                                <h3 class="my-4 text-primary text-center">
                                    Gold-Status
                                </h3>
                                <ol>
                                    <li>Alle Funktionen und Dienstleistungen aus dem Silber-Status</li>
                                    <li>Individuelle Website: Wir erstellen eine neue moderne Website für Sie (inklusive individuellem Design, Fotoshooting, individuellen Texten, Suchmaschinenoptimierung, Responsive Design für alle Endgeräte)</li>
                                    <li>Social-Media Workshop</li>
                                    <li>Individuelle Kampagne inklusive Media-Budget für Patienten-Marketing und / oder zur Mitarbeitersuche</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </section>

    </main>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>